






































import Vue, { PropType } from "vue";
import dayjs from "dayjs";
import IfaceSyncCar from "../../models/IfaceSyncCar";
import SyncStatusBadge from "../SyncStatusBadge.vue";

/**
 * Az aktuális gépjármű köztes sor kompakt összegzése az előzmény panel fölött (a PartnerInfo mintájára).
 */
interface Props {
  car: IfaceSyncCar;
}

interface Computed {
  /** Fejléc: rendszám, ha van, különben alvázszám */
  title: string;
  /** Modell + modell2 egyben */
  model: string;
  /** Gyártási év, csak az év */
  prodYear: string;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "CarInfo",

  components: { SyncStatusBadge },

  props: {
    car: { type: Object as PropType<IfaceSyncCar>, required: true },
  },

  computed: {
    title(): string {
      return this.car.regNum || this.car.bodyNo || "(azonosító nélkül)";
    },
    model(): string {
      return [this.car.modell, this.car.modell2].filter(Boolean).join(" ") || "—";
    },
    prodYear(): string {
      return this.car.prodYear ? dayjs(this.car.prodYear).format("YYYY") : "—";
    },
  },
});
